import store from "../../../../../store";
import { IEditTreeRootSource, ITreeRootSource } from ".";
import { DomainRegistry } from "../../../../../domain";
import { RootDirectory } from "../../../../../domain/drawing";
import { FormatSet } from "../../../../../domain/format";
import { IConfiguration } from "../../../../../domain/configuration";

export class UserFavoriteFormatSetTreeSource implements ITreeRootSource<FormatSet>, IEditTreeRootSource<FormatSet> {
  constructor(private _userId: string, private _shouldIgnoreChained: boolean) {
  }

  private readonly config = store.getters.configuration as IConfiguration;
  entityName: string = "個人" + this.config.wording.format.attributes.name + "セット情報";

  async getTreeRoot(): Promise<RootDirectory<string, FormatSet>> {
    const repository = DomainRegistry.format.getFormatRepository();
    return repository.getUserFavoriteFormatSets(this._userId, this._shouldIgnoreChained);
  }

  async saveEditTreeRoot(root: RootDirectory<string, FormatSet>): Promise<void> {
    const repository = DomainRegistry.format.getFormatRepository();
    return repository.saveUserFormatSets(this._userId, root);
  }

  get managementKey(): string {
    // 競合チェックなし
    return null;
  }
}
